// universe.actions.ts
import { Action } from '@ngrx/store';

export const FETCH = '[Universe FETCH';
export const FETCH_SUCCESS = '[Universe] FETCH_SUCCESS';
export const ADD_UNIVERSE_COMPANY_SUCCESS = '[Universe] ADD_UNIVERSE_COMPANY_SUCCESS';
export const ADD_UNIVERSE_COMPANY_FAILURE = '[Universe] ADD_UNIVERSE_COMPANY_FAILURE';
export const ADD_COMPANY = '[Universe ADD_COMPANY';
export const RESET = '[Universe] RESET';

export class Reset implements Action {
  readonly type = RESET;
  constructor() {}
}

export class Fetch implements Action {
  readonly type = FETCH;
  constructor() {}
}

export class AddCompany implements Action {
  readonly type = ADD_COMPANY;
  constructor(public payload: any) {}
}

export class AddUniverseCompanySuccess implements Action {
  readonly type = ADD_UNIVERSE_COMPANY_SUCCESS;
  constructor() {}
}

export class AddUniverseCompanyFailure implements Action {
  readonly type = ADD_UNIVERSE_COMPANY_FAILURE;
  constructor() {}
}



export class FetchSuccess implements Action {
  readonly type = FETCH_SUCCESS;
  constructor(public payload: any) {}
}

export type Actions = Reset | Fetch | FetchSuccess | AddCompany | AddUniverseCompanySuccess | AddUniverseCompanyFailure;



// WEBPACK FOOTER //
// ./src/actions/universe.actions.ts